import React from 'react';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import { Link, useLocation } from 'react-router-dom';
import Typography from '@material-ui/core/Typography';
import { useHomePath } from '../Modules/nav/hooks';

const NotFoundPage = () => {
    const location = useLocation();
    const homePath = useHomePath();

    return (
        <Box textAlign="center" mt={4}>
            <Typography variant="h2" color="textSecondary">
                Die Seite "{location.pathname}" konnte nicht gefunden werden!
            </Typography>
            <Box mt={4}>
                <Button variant="contained" color="primary" component={Link} to={homePath}>
                    Zur Startseite
                </Button>
            </Box>
        </Box>
    );
};

NotFoundPage.propTypes = {};

NotFoundPage.defaultProps = {};

export default NotFoundPage;
